import { toast } from "react-toastify";

export function packetErrorHandler(e: any) {
    let error: any = "";

    if (e?.response?.status === 403) error = "دسترسی غیرمجاز";
    else if (e.msg) error = e.msg;
    else if (e?.response?.data?.value) error = e.response.data.value;
    if (error === "") error = "خطا در ارتباط با سرور";
    toast.error(error);
  }
